import { ReactNode, useState } from "react";
import Icon from "@mdi/react";
import { mdiChevronDown } from "@mdi/js";

export function Accordion({ title, children, openIconOnly = false }: { title: ReactNode, children: ReactNode, openIconOnly?: boolean }) {
    const [isOpen, setIsOpen] = useState(false);

    return <div className={`accordion ${isOpen ? "open" : ""}`}>
        <div className="accordion-header" onClick={() => !openIconOnly && setIsOpen(!isOpen)}>
            <div className="accordion-title">{title}</div>
            <div className="accordion-icon" onClick={() => setIsOpen(!isOpen)}>
                <Icon path={mdiChevronDown} size={1.5} />
            </div>
        </div>
        <div className="accordion-content">
            <div className="accordion-inner">{children}</div>
        </div>
    </div>;
}
